import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { firstError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import {
  columnDate,
  columnNameLink,
  columnRowCount,
  columnStatus,
  columnTools,
} from '@/constants/fields';
import TableWrapper from '@/components/table/TableWrapper';
import NoRows from '@/components/table/NoRows';
import DatasetStorageErrorRow from '../../components/DatasetStorageErrorRow';
import DictionaryReportsTableRows from './DictionaryReportsTableRows';
import { dictionaryReportTypes } from '../constants';
import DictionaryReportsTableHeader from './DictionaryReportsTableHeader';

const DictionaryReportsTable = ({
  category,
  code,
  readStatus,
  readErrors,
  reports,
  reportType,
}) => {
  const columns = [columnNameLink, columnDate, columnTools];
  if (reportType === dictionaryReportTypes.VALIDATION) {
    columns.push(columnRowCount, columnStatus);
  }
  const error = firstError(readErrors);
  const noReports = (reports.length === 0 && !error && readStatus !== states.PENDING);

  return (
    <>
      <TableWrapper className="aridhia-dataset-dictionary-reports-table">
        <DictionaryReportsTableHeader columns={columns} readStatus={readStatus} reportType={reportType} />
        <Table.Body className={clsx(reports.length >= 6 && 'overflow-scroll')}>
          {error && (<DatasetStorageErrorRow colSpan={columns.length} error={error} />)}
          <DictionaryReportsTableRows
            category={category}
            code={code}
            columns={columns}
            reports={reports}
            reportType={reportType}
          />
        </Table.Body>
      </TableWrapper>
      {noReports && (<NoRows icon="file" entity={`dataset.data.dictionary.${reportType}.reports`} />)}
    </>
  );
};

export default DictionaryReportsTable;
